<template>
  <b-modal
    ref="helperModal"
    :visible="showContextAssistant"
    centered
    title="Pomoc- objaśnienie funkcji"
    @hide="cancel"
  >
    <div class="form-horizontal" style="word-wrap: break-word;">
      <span v-html="message"></span>
    </div>
    <div slot="modal-footer" class="text-right">
      <b-btn variant="outline-secondary" @click="cancel">Zamknij</b-btn>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { HIDE_CONTEXT_ASSISTANT_MESSAGE } from '../store/actions.type';

export default {
  name: 'ContextAssistantModal',
  data: function() {
    return {
      message: undefined,
      cancel: function() {}
    };
  },
  computed: {
    ...mapGetters(['showContextAssistant'])
  },
  watch: {
    showContextAssistant(value) {
      if (value) {
        const contextAssistantData = this.$store.getters.contextAssistant;
        this.setMessage(contextAssistantData.message);
        this.setNoAction(contextAssistantData.noAction);
      }
    }
  },
  methods: {
    setMessage(message) {
      this.message = message;
    },

    setNoAction(action) {
      const self = this;

      self.cancel = function() {
        if (action) {
          action();
        }
        self.hide();
      };
    },

    hide() {
      this.$store.dispatch(HIDE_CONTEXT_ASSISTANT_MESSAGE);
    }
  }
};
</script>
